import { atom } from 'recoil';
import { recoilPersist } from "recoil-persist"
const { persistAtom } = recoilPersist();
export const setClinicId = atom({
    key: 'setClinicId', 
    default: '',
    effects_UNSTABLE: [persistAtom]
});  